<script>
import { event } from "vue-analytics";

import Logo from "./Logo";
import vMain from "./Main";
import Account from "./Steps/Account";
import Profile from "./Steps/Profile";
import Accountable from "./Steps/Accountable/Index";
import ComeBack from "./ComeBack";

import { mapState, mapActions } from "vuex";

const STEP_COMPONENTS = ["v-main", "account", "profile", "accountable"];

export default {
  components: {
    Logo,
    vMain,
    Account,
    Profile,
    Accountable,
    ComeBack
  },
  computed: {
    ...mapState("signUp", ["step", "accountableType"]),
    stepComponent() {
      return STEP_COMPONENTS[this.step];
    }
  },
  methods: {
    ...mapActions("signUp", ["resetState"])
  },

  mounted() {
    pintrk("track", "signup");

    try {
      if (
        this.$route.params.lastRoute.query &&
        this.$route.params.lastRoute.query.source &&
        this.$route.params.lastRoute.query.source === "homepage"
      ) {
        event("cliente", "register", "register:start:old-flow");
      }
    } catch (e) {}
  },

  beforeDestroy() {
    this.resetState();
  }
};
</script>

<template>
  <div id="base">
    <base-card>
      <logo />

      <transition name="fade" mode="out-in">
        <component class="content" :is="stepComponent" />
      </transition>
      <come-back />
    </base-card>

  </div>
</template>

<style lang="scss" scoped>
div#base {
  @extend %flex-column-center;
  min-height: calc(100vh - 40px);
  transition: all 0.5s ease;
  padding-top: 40px;
}

.content {
  width: 360px;
  max-width: calc(100%);
}
</style>



// WEBPACK FOOTER //
// src/components/SignUp/Index.vue